"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _image = _interopRequireDefault(require("../image"));
var mapCategoryBanners = function mapCategoryBanners(response) {
  if (!response) return false;
  return response.data.body.map(function (banner) {
    if (banner.slice_type === "categorybanner") {
      var _banner$primary$url, _banner$primary$url2, _banner$primary$text$;
      return {
        categoryId: banner.primary.categoryid,
        position: banner.primary.position,
        url: (_banner$primary$url = banner.primary.url) !== null && _banner$primary$url !== void 0 && _banner$primary$url.url ? (_banner$primary$url2 = banner.primary.url) === null || _banner$primary$url2 === void 0 ? void 0 : _banner$primary$url2.url.replace("https:/", "") : "/",
        text: (_banner$primary$text$ = banner.primary.text[0]) === null || _banner$primary$text$ === void 0 ? void 0 : _banner$primary$text$.text,
        image: (0, _image["default"])(banner.primary.image)
      };
    }
  });
};
var _default = mapCategoryBanners;
exports["default"] = _default;